
import { Component, Vue, Prop } from 'vue-property-decorator'
import { modifyOrderStatusBulk } from '@/api/task/withdraw'
import { bulkChanges } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'approval',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private infoList!: any[]
  @Prop({ required: true }) private ordernumbers!: any[]

  get language () {
    return AppModule.language
  }
  private statusList: any[] = []
  private setForm: any = {
    status: null,
    remarks: '',
    google_code: ''
  }
  private rules = bulkChanges
  private loading: boolean = false
  private productList: any[] = []
  private accountList: any[] = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.setForm = {
      product: null,
      product_account: null,
      google_code: ''
    }
    this.$emit('close')
  }

  private async modifyOrderStatusBulk () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumbers: this.ordernumbers,
          ...this.setForm
        }
        try {
          await modifyOrderStatusBulk(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Approval successfully!',
                type: 'success'
              })
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private selProduct () {
    this.setForm.product_account = null
  }

  created () {}
}
